import type { ModuleMaster } from '../types/module.types';

export const buildModuleTree = (modules: ModuleMaster[]): ModuleMaster[] => {
  const moduleMap = new Map<number, ModuleMaster>();
  const roots: ModuleMaster[] = [];

  // First, filter modules that have REVEAL = true
  const revealedModules = modules.filter(module => module.REVEAL);

  revealedModules.forEach(module => {
    moduleMap.set(module.ID, { ...module, children: [] });
  });

  revealedModules.forEach(module => {
    if (module.PARENT) {
      const parent = moduleMap.get(module.PARENT);
      if (parent) {
        parent.children!.push(moduleMap.get(module.ID)!);
      }
    } else {
      roots.push(moduleMap.get(module.ID)!);
    }
  });

  return roots.sort((a, b) => a.SEQUENCE - b.SEQUENCE);
};

export const hasAccessToRoute = (modules: ModuleMaster[], route: string): boolean => {
  return modules.some(module => module.ROUTE === route);
};